// SPDX-License-Identifier: AGPL-3.0-or-later

export const OAuth2Scopes = ['identify', 'email', 'guilds', 'connections', 'bot'] as const;

export type OAuth2Scope = (typeof OAuth2Scopes)[number];

// Discord bot invite links carry this scope; bots here register commands without it.
const IMPLIED_OAUTH2_SCOPES: ReadonlySet<string> = new Set(['applications.commands']);

export function splitOAuth2Scopes(scope: string): Array<string> {
	return scope.split(/[\s+]+/).filter((s) => s.length > 0 && !IMPLIED_OAUTH2_SCOPES.has(s));
}
